import { medicationDetails, medicationDetailsForTransfer } from 'src/app/router/paths';
import { HomeItemType } from 'src/app/types';

import { HeaderText, SecondaryText, StyledLink, TextContainer } from './styles';

interface MedicationNameSectionProps {
  genericName?: string;
  prescriptionId: string;
  primaryName: string;
  goToMedDetailsOnMedNameClick?: boolean;
  showSecondaryName: boolean;
  type: HomeItemType;
}

export const MedicationNameSection = ({
  genericName,
  prescriptionId,
  primaryName,
  goToMedDetailsOnMedNameClick = false,
  showSecondaryName,
  type,
}: MedicationNameSectionProps) => {
  return (
    <>
      {goToMedDetailsOnMedNameClick ? (
        <TextContainer>
          <StyledLink
            to={
              type === HomeItemType.transfer
                ? medicationDetailsForTransfer.toPath({ prescriptionId })
                : medicationDetails.toPath({ prescriptionId })
            }
            aria-label={`Navigate to Medication Details for ${primaryName}`}
          >
            <HeaderText data-cy="medication-name">{primaryName}</HeaderText>
          </StyledLink>
        </TextContainer>
      ) : (
        <HeaderText data-cy="medication-name">{primaryName}</HeaderText>
      )}
      {showSecondaryName && <SecondaryText>{genericName}</SecondaryText>}
    </>
  );
};
